import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/gameDownload/"

export function insertGameDownload(data) {
    return Post(baseUrl + "insertGameDownload", data)
}

export function batchInsertGameDownload(data) {
    return Post(baseUrl + "batchInsertGameDownload", data)
}

export function deleteGameDownload(data) {
    return Post(baseUrl + "deleteGameDownload", data)
}

export function updateGameDownload(data) {
    return Post(baseUrl + "updateGameDownload", data)
}

export function queryGameDownload(data) {
    return Post(baseUrl + "queryGameDownload", data)
}